// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import DocumentSchema from './document-schema';

const schema = {
  $id: '/safety-anchor-point-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'safetyHookId'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    name: {
      type: 'string',
      nullable: true,
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    position: {
      type: 'string',
      nullable: true,
    },
    safetyHookId: {
      type: 'integer',
    },
    screwLength: {
      type: 'string',
      nullable: true,
    },
    isInstalledOnCounterBatten: {
      type: 'boolean',
    },
    documentList: {
      type: 'array',
      nullable: true,
      items: { ...DocumentSchema },
    },
    installationRemark: {
      type: 'string',
      nullable: true,
    },
    installationDate: {
      type: 'string',
      format: 'date-time',
    },
    isDocumentationCompleted: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
